import { createApp } from 'vue'
import App from './App.vue'
import '../../css/frontend.css'

import 'aos/dist/aos.css'
import AOS from 'aos'

AOS.init({
  duration: 1000,
  once: true,
})

createApp(App).mount('#app')
